import { NgModule } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { KeyFilterModule } from 'primeng/keyfilter';
import { TableModule } from 'primeng/table';
import { InputMaskModule } from 'primeng/inputmask';
import { CalendarModule } from 'primeng/calendar';
import { TreeModule } from 'primeng/tree';
import { AccordionModule } from 'primeng/accordion';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { SkeletonModule } from 'primeng/skeleton';
import { ToolbarModule } from 'primeng/toolbar';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { CardModule } from 'primeng/card';
import { ProgressBarModule } from 'primeng/progressbar';
import { InputNumberModule } from 'primeng/inputnumber';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { TagModule } from 'primeng/tag';

@NgModule({
  declarations: [],
  imports: [
    DialogModule,
    KeyFilterModule,
    ToastModule,
    FileUploadModule,
    ButtonModule,
    AutoCompleteModule,
    DropdownModule,
    CheckboxModule,
    InputTextModule,
    TableModule,
    InputMaskModule,
    CalendarModule,
    TreeModule,
    AccordionModule,
    OverlayPanelModule,
    DynamicDialogModule,
    SkeletonModule,
    ToolbarModule,
    MultiSelectModule,
    InputTextareaModule,
    ConfirmPopupModule,
    CardModule,
    ProgressBarModule,
    InputNumberModule,
    AvatarModule,
    AvatarGroupModule,
    TagModule
  ],
  exports: [
    DialogModule,
    KeyFilterModule,
    ToastModule,
    FileUploadModule,
    ButtonModule,
    AutoCompleteModule,
    DropdownModule,
    CheckboxModule,
    InputTextModule,
    TableModule,
    InputMaskModule,
    CalendarModule,
    TreeModule,
    AccordionModule,
    OverlayPanelModule,
    DynamicDialogModule,
    SkeletonModule,
    ToolbarModule,
    MultiSelectModule,
    InputTextareaModule,
    ConfirmPopupModule,
    CardModule,
    ProgressBarModule,
    InputNumberModule,
    AvatarModule,
    AvatarGroupModule,
    TagModule
  ],
})
export class PrimengSharedModule {}
